import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  svg: {
    width: '183',
    height: '268',
  },
  path: {
    fill: '#FFDB00',
  },
});

export const LinkBreakIcon = () => {
  const classes = useStyles();

  return (
    <svg
      width="183"
      height="268"
      viewBox="0 0 183 268"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes.svg}
    >
      <path
        d="M138.45 219.716L137.414 220.768L138.45 221.82L146.198 229.691L147.267 230.777L148.336 229.691L152.212 225.754C165.629 212.126 165.629 190.041 152.212 176.414L132.715 156.61C129.057 152.894 129.057 146.931 132.715 143.215C136.455 139.417 142.581 139.417 146.32 143.215L165.576 162.774C186.404 183.929 186.404 218.238 165.576 239.394L144.57 260.73C141.792 263.551 137.243 263.551 134.465 260.731L107.765 233.612C105.048 230.852 105.048 226.423 107.766 223.663L128.273 202.838C129.231 201.865 129.231 200.304 128.273 199.33L109.467 180.228C105.809 176.512 105.809 170.549 109.467 166.833C113.206 163.035 119.332 163.035 123.072 166.833L142.327 186.392C150.314 194.504 150.314 207.665 142.327 215.777L138.45 219.716Z"
        fill="#111111"
        stroke="white"
        strokeWidth="3"
      />
      <path
        d="M26.6511 55.3381L26.6511 55.338L46.074 19.246C47.9502 15.7597 52.318 14.4855 55.7744 16.4161L88.9985 34.9736C92.3793 36.8619 93.6195 41.1135 91.7842 44.5233L72.6973 79.9859C72.0502 81.1883 72.4875 82.6875 73.6796 83.3534L97.0831 96.4254C101.635 98.9681 103.305 104.693 100.834 109.284C98.3074 113.978 92.4266 115.693 87.7728 113.094L63.8109 99.7099C53.8727 94.1588 50.1872 81.5238 55.5825 71.5002L63.4366 56.9084L64.1365 55.608L62.8472 54.8879L53.2048 49.502L51.8746 48.7591L51.1525 50.1007L43.2993 64.6907C34.2356 81.5298 40.4198 102.731 57.1154 112.057L81.3783 125.609C85.9305 128.151 87.6004 133.876 85.1291 138.467C82.6027 143.161 76.7218 144.876 72.0681 142.277L48.1062 128.893C22.1877 114.416 12.5804 81.4794 26.6511 55.3381Z"
        fill="#111111"
        stroke="white"
        strokeWidth="3"
      />
      <rect
        x="0.515071"
        y="0.480033"
        width="15.3704"
        height="29.9234"
        rx="7.68521"
        transform="matrix(0.999221 -0.039456 0.0309202 0.999522 115.998 66.8181)"
        fill="#111111"
        stroke="white"
      />
      <rect
        x="-0.424699"
        y="-0.558501"
        width="15.3591"
        height="29.9473"
        rx="7.67957"
        transform="matrix(-0.991877 -0.127204 0.142478 -0.989798 83.4995 219.738)"
        fill="#111111"
        stroke="white"
      />
      <rect
        x="0.024329"
        y="0.686209"
        width="14.8545"
        height="30.9806"
        rx="7.42726"
        transform="matrix(0.75087 0.660451 -0.702211 0.711968 160.218 70.8232)"
        fill="#111111"
        stroke="white"
      />
      <rect
        x="0.0923698"
        y="-0.680933"
        width="14.7996"
        height="31.0892"
        rx="7.39978"
        transform="matrix(-0.627534 -0.778589 0.812274 -0.583277 42.5671 208.844)"
        fill="#111111"
        stroke="white"
      />
      <rect
        x="-0.484151"
        y="0.519489"
        width="14.4617"
        height="31.7408"
        rx="7.23086"
        transform="matrix(0.0309202 0.999522 -0.999221 0.039456 179.022 108)"
        fill="#111111"
        stroke="white"
      />
      <rect
        x="0.567177"
        y="-0.431297"
        width="14.4737"
        height="31.7183"
        rx="7.23683"
        transform="matrix(0.142478 -0.989798 0.991877 0.127205 30.1192 170.975)"
        fill="#111111"
        stroke="white"
      />
    </svg>
  );
};

export default LinkBreakIcon;
